<template>
    <div class="text-input-component mb-6 pr-0 lg:pr-4 text-left w-full"
         :class="{'lg:w-1/2':!width, 'full-pad':width==='full'}"
    >
        <label v-if="label" class="form-label" :for="uniqueId">{{ label }}:</label>
        <input
            :id="uniqueId"
            ref="input"
            v-bind="$attrs"
            class="form-input"
            :class="{ error: error }"
            :type="type"
            :value="modelValue"
            @input='$emit("update:modelValue", $event.target.value)'
        />
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return ''
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        help: {
            type: String,
            default: '',
        },
        value: String,
        modelValue: String,
        label: String,
        error: String,
        customClass: String,
        width: {type: String, default: null},
    },
    data () {
        return {
            uniqueId: null,
        }
    },
    beforeCreate() {
        this.uniqueId = `text-input-${this._uid}`
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
        setSelectionRange(start, end) {
            this.$refs.input.setSelectionRange(start, end)
        },
    },
}
</script>
<style scoped>
.text-input-component:nth-of-type(even) {
    padding-right: 0;
}

.full-pad {
    padding-right: 1rem !important;
}
</style>